import {EvaluationResult } from "../../evaluators/EvaluationResult";
import { LomaEvaluator } from "./LomaEvaluator";
import { LomaParser } from "./LomaParser";

export class Loma
{

  static compute( source:string ):any
  {
    if ( source === "" || source.trim() === "" )
    {
      return undefined;
    }


    let parser = new LomaParser();

    try
    {
      console.log( "parsing:", `"${source}"`) ;
      parser.parse( source );
    }
    catch( e ) 
    {
      console.error( e );
      return undefined;
    }    

    if ( parser.hasErrors )
    {
      return undefined;
    }
 
    let evaluator = new LomaEvaluator();

    try
    {
      console.log( "evaluating:", parser.lomaOperatorProcessor );
      let result = evaluator.evaluate( parser.lomaOperatorProcessor.parsedExpressions[ 0 ] );
      console.log( "result:", result.messages, result.data, result );
      return result.data;

    }
    catch ( e )
    {
      console.error( e );
      return undefined;
    }

    
  }
}